import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from "react";

/**
 * Hook to detect if the app is running in standalone PWA mode
 * Checks display-mode media query and navigator.standalone
 */
export function useStandaloneDetection() {
  const $ = _c(2);
  const [isStandalone, setIsStandalone] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      if (typeof window !== "undefined") {
        const isInStandaloneMode = window.matchMedia("(display-mode: standalone)").matches || (window.navigator as any).standalone || document.referrer.includes("android-app://");
        setIsStandalone(isInStandaloneMode);
        const mediaQueryList = window.matchMedia("(display-mode: standalone)");
        const handleChange = e => {
          setIsStandalone(e.matches || (window.navigator as any).standalone || false);
        };
        if (mediaQueryList.addEventListener) {
          mediaQueryList.addEventListener("change", handleChange);
        } else {
          if (mediaQueryList.addListener) {
            mediaQueryList.addListener(handleChange);
          }
        }
        return () => {
          if (mediaQueryList.removeEventListener) {
            mediaQueryList.removeEventListener("change", handleChange);
          } else {
            if (mediaQueryList.removeListener) {
              mediaQueryList.removeListener(handleChange);
            }
          }
        };
      }
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return isStandalone;
}